module.exports = __webpack_public_path__ + "static/media/1Asset-10Warehouse2.4a402b79.png";